import { render, staticRenderFns } from "./placeDetail.vue?vue&type=template&id=7837ff44&scoped=true"
import script from "./placeDetail.vue?vue&type=script&lang=js"
export * from "./placeDetail.vue?vue&type=script&lang=js"
import style0 from "./placeDetail.vue?vue&type=style&index=0&id=7837ff44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837ff44",
  null
  
)

export default component.exports